export const itemCategoryMapping = {
  support: ["websupport", "gamesupport"],
  newsinformation: ["news", "updates"],
  gamediscussion: ["discussion", "help", "lfg"],
};

  // uncategorized: ["uncategorized"],